export default class filterSearch {
    /*
     * Fires first
     */
    constructor() {
        // Add events
        this.addEvents(); 
    }

    /*
     * Add events
     */
    addEvents(){

        //Clear filter
        $(document).on('click', '.js-search-filter__clear' , e => {
           e.preventDefault();
            $('.js-search-filter__clear').find('img').toggleClass('rotate-360');
            $('.js-search-filter__input').val('all').trigger('change');
            $('.js-search-filter__post-type').val('all').trigger('change');

            this.ajaxCall($(e.currentTarget));
        });


        //Run Ajax call when change order
        $(document).on('change', '.js-search-sort-order' , e => {
            let currentOrder = $(e.currentTarget).val();
            $('.js-search-sort-order').val(currentOrder);
            this.ajaxCall($(e.currentTarget));
        });

    
        // Search specific filter
        $(document).on('click', '.js-search-prev-page, .js-search-next-page, .js-search-filter__submit, .js-search-filter__submit', e => {
            e.preventDefault();
            this.ajaxCall($(e.currentTarget));

            let postType = '';
 
            postType = $('.js-search-filter__post-type').val();

            let url = new URL(window.location.href + '?type=post');
            let search_params = url.searchParams;

            // new value of "id" is set to "101"
            search_params.set('type', postType);

            // change the search property of the main url
            url.search = search_params.toString();

            // the new url string
            let new_url = url.toString();

            history.pushState({
                id: 'type',
                source: 'web',
            }, 'Type', new_url ); 
        });
    }

    // Ajax call to get posts, pagination and posts counter
    ajaxCall( $currentElement ){ 
        let currentPage = $('.js-search-current-page').first().text();
        let order = 'newest'
        let search = $('.js-search-filter__value-search').val();

        //Calculate pagination
        if( $currentElement.hasClass('js-search-next-page') ) {
            currentPage = parseInt(currentPage) + 1
        } else if( $currentElement.hasClass('js-search-prev-page') ) {
            currentPage = parseInt(currentPage) - 1
        } else {
            currentPage = 1
        }

        // Check order
        if( $currentElement.hasClass('js-search-sort-order') ){
            order = $currentElement.val();
        }

        let data = {
            action: 'filterSearch', 
            currentPage: currentPage,
            order: order,
            search: search,
            type: $('.js-search-filter__post-type').val(),
        }

        $.ajax({
            type: 'GET',
            url: ajaxObject.ajax_url,
            dataType: "json",
            data: data,
            beforeSend: () => {
                $('.js-search-wrap-posts').addClass('opacity-40', 'pointer-events-none');
            },
            success: (result) => { 
                
                $('.js-satellite--result-amount').val(result.data.satellite_result_amount);

                $('.js-search-list-post').empty();
                $('.js-search-no-posts').hide();
                $('.js-search-wrap-posts').removeClass('opacity-40', 'pointer-events-none');

                if( result.data.posts){ 
                        $('.js-listing-actionbar__pagination').html( result.data.pagination );
                        $('.js-listing-actionbar__results').html( result.data.posts_counter ); 

                        let posts = result.data.posts;

                        posts.forEach(element => {
                            // console.log(element.category);
                            let category = '';

                            if( element.category ) {
                                category = ' | ' + element.category;
                            }

                            let satelliteClass = "";
                            let satelliteCat = "";
                            if( element.fileType === 'pdf' ) { 
                                satelliteClass == 'js-satellite--click-download'
                                if( element.category ){
                                    satelliteCat = 'data-st-download-cat="'+element.category.replace(/(<([^>]+)>)/gi, "")
                                } 
                            }


                            let buttonDownload = '';
                            if( element.button_download ){
                                buttonDownload = 'target="_blank" download';
                            }
                            

                            if( element.fileType === 'pdf' ) {
                                satelliteClass == 'js-satellite--click-download';
                                // satelliteCat = 'data-st-download-cat="' + element.category + '"';
                            }

                            let post = '<article class="relative">';

                            if( element.image ) {
                                post += '<a href="' + element.url + '" '+ buttonDownload +' class="col-span-2">' +
                                    '<img loading="lazy" src="' + element.image + '" class="h-[200px] object-contain px-2 mx-auto w-full" alt="' + element.alt + '">' +
                                '</a>';
                            }
                            post += '<div class="px-4 col-span-4">' +
                                    '<div class="my-3">' +
                                        '<time class="font-bold inline-block" datetime="' + element.date + '">' + element.date + '</time>' + category +
                                    '</div>' +
                                    '<h4 class="lg:pb-12">' + element.title + '</h4>' +
                                    '<a href="' + element.url + '" ' + satelliteCat + ' class="js-cc-post-btn ' + satelliteClass + ' btn-no-bg absolute lg:bottom-0" '+buttonDownload+'>' + element.button_content + '</a>' +
                                '</div>' +
                            '</article>';

                            $('.js-search-list-post').append(post);
                        });
                    }else{
                        $('.js-search-no-posts').show();
                    }

                if( $( document ).width() <= 1024 && !$currentElement.hasClass('js-search-filter__clear') ){
                    $('.js-mobile-filter--cloend').slideUp();
                }

                // scroll on the top of page when results are ready on the page
                $('html, body').animate({
                    scrollTop: ($('.js-search-wrap-posts').offset().top - 200),
                },500);
            },
        });
    }

}
